import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { 
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, 
  Button, TextField, Dialog, DialogActions, DialogContent, DialogTitle,
  Typography, Box, MenuItem, IconButton, Tooltip 
} from '@mui/material';
import { Add as AddIcon, Edit as EditIcon, Delete as DeleteIcon } from '@mui/icons-material';
import CustomAxios from '../utils/CustomAxios';

const PoolAndShare = () => {
  const [packages, setPackages] = useState([]);
  const [open, setOpen] = useState(false);
  const [editId, setEditId] = useState(null); // Track if we are editing
  const [formData, setFormData] = useState({
    name: '', accumulated: 0, percentage: 0, country: '', status: 'active'
  });

  const API_URL = '/pool/';

  useEffect(() => { fetchPackages(); }, []);

  const fetchPackages = async () => {
    const res = await CustomAxios.get(API_URL);
    // console.log(res.data)
    setPackages(res.data);
  };

  const handleOpen = (pkg = null) => {
    if (pkg) {
      setEditId(pkg.id);
      setFormData(pkg);
    } else {
      setEditId(null);
      setFormData({ name: '', accumulated: 0, percentage: 0, country: '', status: 'active' });
    }
    setOpen(true);
  };

//   const handleDelete = async (id) => {
//     if (window.confirm("Are you sure you want to delete this package?")) {
//       await axios.delete(`${API_URL}${id}/`);
//       fetchPackages();
//     }
//   };

  const handleSubmit = async () => {
    if (editId) {
      await CustomAxios.put(`${API_URL}${editId}/`, formData);
    } else {
      await CustomAxios.post(API_URL, formData);
    }
    setOpen(false);
    fetchPackages();
  };

  return (
    <Box sx={{ }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
        <Typography variant="h6" fontWeight="bold">Pool and Share Configuration</Typography>
        <Button variant="contained" startIcon={<AddIcon />} onClick={() => handleOpen()}
          sx={{ bgcolor: '#00bcd4', '&:hover': { bgcolor: '#00acc1' } }}>
          Create Pools
        </Button>
      </Box>

      <TableContainer >
        <Table>
          <TableHead sx={{ bgcolor: '#f5f5f5' }}>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell align="right">Percentage</TableCell>
              <TableCell align="right">Total Accumulated</TableCell>

              <TableCell align="right">Accumulated</TableCell>
              <TableCell align="right">Status</TableCell>
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {packages.map((pkg) => (
              <TableRow key={pkg.id} hover>
                <TableCell>{pkg.name}</TableCell>
                <TableCell align="right">{pkg.percentage}%</TableCell>
                <TableCell align="right">${pkg.total_accumulated}</TableCell>

                <TableCell align="right">${pkg.accumulated}</TableCell>
                <TableCell align="right" sx={{ textTransform: 'capitalize' }}>{pkg.status}</TableCell>
                <TableCell align="center">
                  <Tooltip title="Edit">
                    <IconButton onClick={() => handleOpen(pkg)} color="primary"><EditIcon /></IconButton>
                  </Tooltip>
                  {/* <Tooltip title="Delete">
                    <IconButton onClick={() => handleDelete(pkg.id)} color="error"><DeleteIcon /></IconButton>
                  </Tooltip> */}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Unified Create/Edit Dialog */}
      <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="xs">
        <DialogTitle>{editId ? 'Edit Pool' : 'Create New Pool'}</DialogTitle>
        <DialogContent dividers sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <TextField label="Pool Name" fullWidth value={formData.name} 
            onChange={(e) => setFormData({...formData, name: e.target.value})} />
          <TextField label="Percentage" type="number" fullWidth value={formData.percentage}
            onChange={(e) => setFormData({...formData, percentage: e.target.value})} />
          {/* <TextField label="Accumulated" type="number" fullWidth value={formData.accumulated}
            onChange={(e) => setFormData({...formData, accumulated: e.target.value})} /> */}
          <TextField select label="Status" fullWidth value={formData.status}
            onChange={(e) => setFormData({...formData, status: e.target.value})}>
            <MenuItem value="active">Active</MenuItem>
            <MenuItem value="inactive">Inactive</MenuItem>
          </TextField>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button variant="contained" onClick={handleSubmit}>{editId ? 'Update' : 'Save'}</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default PoolAndShare;